<template>
    <div class="uik-widget-content__wrapper" :class="{ 'uik-widget-content__wrapper--compact': compact }">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: "UikWidgetContent",
    props: {
        compact: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
.uik-widget-content__wrapper {
  padding: 25px 30px;
  &+& {
    border-top: $borderDefault;
  }
  &.uik-widget-content__grey {
    background-color: $bg;
  }
  &.uik-widget-content__wrapper--compact {
    padding: 12px 30px;
  }
}
</style>
